(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halloween-product-countdown"] && !Shopify.designMode) return;
  try {
    (function() {
    var timers = document.querySelectorAll('[data-product-halloween-countdown]');
    if (!timers.length) return;

    var duration = 5 * 24 * 60 * 60 * 1000;
    var storageKey = 'everwallpaper_halloween_countdown_end_v1';
    var end = 0;

    function saveEnd(value) {
      end = value;
      try {
        window.localStorage.setItem(storageKey, String(value));
      } catch (error) {}
    }

    function loadEnd() {
      try {
        end = parseInt(window.localStorage.getItem(storageKey), 10) || 0;
      } catch (error) {
        end = 0;
      }

      if (end <= Date.now()) saveEnd(Date.now() + duration);
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function update() {
      var remaining = end - Date.now();

      if (remaining <= 0) {
        saveEnd(Date.now() + duration);
        remaining = end - Date.now();
      }

      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);

      timers.forEach(function(timer) {
        timer.querySelector('[data-product-days]').textContent = pad(days);
        timer.querySelector('[data-product-hours]').textContent = pad(hours);
        timer.querySelector('[data-product-minutes]').textContent = pad(minutes);
        timer.querySelector('[data-product-seconds]').textContent = pad(seconds);
        timer.querySelector('[role="timer"]').setAttribute('aria-label', days + ' days, ' + hours + ' hours, ' + minutes + ' minutes, ' + seconds + ' seconds remaining');
      });
    }

    loadEnd();
    update();
    window.setInterval(update, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
